import React from "react";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { colors } from "../../../utils/colors";

const VehicleTableHeader: React.FC = () => {
  const headerStyle = {
    fontFamily: "SigmaSans",
    fontWeight: "bold",
    width: "14.29%",
  };

  return (
    <TableHead sx={{ backgroundColor: colors.background }}>
      <TableRow>
        <TableCell style={headerStyle}>LICENSE PLATE</TableCell>
        <TableCell style={headerStyle} align="left">
          LAST SEEN
        </TableCell>
        <TableCell style={headerStyle} align="left">
          YARD
        </TableCell>
        <TableCell style={headerStyle} align="center">
          AVAILABLE
        </TableCell>
        <TableCell style={headerStyle} align="center">
          DETAILS
        </TableCell>
        <TableCell style={headerStyle} align="center"></TableCell>
        <TableCell style={headerStyle} align="center"></TableCell>
      </TableRow>
    </TableHead>
  );
};

export default VehicleTableHeader;
